(function () {
  var MIN_QTY = 1;
  var MAX_QTY = 99;

  function clampQty(value) {
    var qty = parseInt(String(value), 10);
    if (isNaN(qty) || qty < MIN_QTY) return MIN_QTY;
    if (qty > MAX_QTY) return MAX_QTY;
    return qty;
  }

  function readTicketQty(btn) {
    var ticket = btn.closest('.sacbe-above__ticket');
    if (!ticket) return MIN_QTY;
    var input = ticket.querySelector('[data-sacbe-above-qty-input]');
    if (!input) return MIN_QTY;
    var qty = clampQty(input.value);
    input.value = String(qty);
    return qty;
  }

  function setTicketQty(input, nextQty) {
    input.value = String(clampQty(nextQty));
  }

  function getRoutes() {
    return window.routes || {};
  }

  function getCartAddUrl() {
    var routes = getRoutes();
    return routes.cart_add_url || '/cart/add.js';
  }

  function getCartUrl() {
    var routes = getRoutes();
    return routes.cart_url || '/cart';
  }

  function getErrorMessage(payload, fallback) {
    if (!payload) return fallback;
    var message = payload.description || payload.message;
    if (message) return String(message).replace(/<[^>]*>/g, '').trim();
    if (payload.errors) {
      return typeof payload.errors === 'string' ? payload.errors : JSON.stringify(payload.errors);
    }
    return fallback;
  }

  function isCartAddError(payload) {
    if (!payload) return true;
    var status = payload.status;
    return status === 422 || status === '422' || (typeof status === 'number' && status >= 400);
  }

  function notifyCartUpdate(payload) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sacbe-above-landing', cartData: payload });
      }
    } catch (error) {
      console.warn('Sacbe Above cart publish failed', error);
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function sacbeAboveAddToCart(btn) {
    var variantId = parseInt(String(btn.getAttribute('data-variant-id') || ''), 10);
    if (!variantId || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

    var quantity = readTicketQty(btn);
    var original = (btn.textContent || '').trim();

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || isCartAddError(payload)) {
            throw new Error(getErrorMessage(payload, 'Could not add to cart'));
          }
          return payload;
        });
      })
      .then(function (payload) {
        notifyCartUpdate(payload);
        window.location.assign(getCartUrl());
      })
      .catch(function (err) {
        btn.textContent = original;
        window.alert(
          err && err.message ? err.message : 'Unable to add this pass to your cart right now. Please try again.'
        );
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        if ((btn.textContent || '').trim() === 'Adding…') btn.textContent = original;
      });
  }

  document.addEventListener('click', function (event) {
    var stepBtn = event.target.closest('[data-sacbe-above-qty-step]');
    if (stepBtn) {
      var qtyRoot = stepBtn.closest('[data-sacbe-above-qty]');
      if (!qtyRoot || !qtyRoot.closest('.sacbe-above') || stepBtn.disabled) return;

      var input = qtyRoot.querySelector('[data-sacbe-above-qty-input]');
      if (!input || input.disabled) return;

      event.preventDefault();
      var step = Number(stepBtn.getAttribute('data-sacbe-above-qty-step') || 0);
      setTicketQty(input, clampQty(input.value) + step);
      return;
    }

    var atcBtn = event.target.closest('[data-sacbe-above-atc]');
    if (!atcBtn || !atcBtn.closest('.sacbe-above')) return;

    event.preventDefault();
    sacbeAboveAddToCart(atcBtn);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-sacbe-above-qty-input]');
    if (!input || !input.closest('.sacbe-above')) return;
    setTicketQty(input, input.value);
  });

  document.addEventListener(
    'focusout',
    function (event) {
      var input = event.target.closest('[data-sacbe-above-qty-input]');
      if (!input || !input.closest('.sacbe-above')) return;
      setTicketQty(input, input.value);
    },
    true
  );

  function setAboveMainOffset() {
    if (!document.body.classList.contains('template-page-above')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var y = main.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    document.documentElement.style.setProperty('--sacbe-above-main-offset', Math.max(0, Math.round(y)) + 'px');
  }

  setAboveMainOffset();
  document.addEventListener('DOMContentLoaded', setAboveMainOffset);
  window.addEventListener('load', setAboveMainOffset);
  window.addEventListener('resize', setAboveMainOffset);
  document.addEventListener('shopify:section:load', setAboveMainOffset);
})();
